// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperAbstract-cls1__bbcf92bf934eeea5e4d7{/*!*/}.PaperAbstract-cls2___d17c500c1dd9e70d25b{line-height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperAbstract-cls1__bbcf92bf934eeea5e4d7",
	"cls2": "PaperAbstract-cls2___d17c500c1dd9e70d25b PaperAbstract-cls1__bbcf92bf934eeea5e4d7"
};
export default ___CSS_LOADER_EXPORT___;
